<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="permissionCode"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';
import { toDateTimeString } from '@/utils/date';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    countries() {
      return this.$store.getters['country/loadedItems'];
    },
    columns() {
      return [
        {
          field: 'countryCode',
          label: 'vat.countryCode',
          width: '80px',
          filter: {
            type: 'select',
            options: this.countries,
            valueField: 'code',
            labelField: 'code'
          }
        },
        {
          field: 'vatPercentage',
          label: 'vat.vatPercentage'
        },
        {
          field: 'glCodeSales',
          label: 'vat.glCodeSales'
        },
        {
          field: 'glCodePurchase',
          label: 'vat.glCodePurchase'
        },
        {
          field: 'startDate',
          label: 'vat.startDate',
          type: 'date',
          filter: { type: 'date' }
        }
      ];
    }
  },
  watch: {
    countries(countries) {
      this.getColumn('countryCode').filter.options = countries;
    }
  },
  async created() {
    await this.$store.dispatch('country/getItems');
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary({ countryCode, startDate, vatPercentage }) {
      const date = toDateTimeString(startDate, 'DD-MM-YYYY');
      return `${countryCode} ${date} ${vatPercentage}%`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
